module.exports = __webpack_public_path__ + "static/img/ai-float-window-shadow.5e76f263.svg";